export default __webpack_public_path__ + "static/media/Mohamed Abo Romana.65849be1.jpeg";